import { FormControl } from '@mui/material';
import { createFormHook } from '@tanstack/react-form';

import { AutocompleteField, ListManager, SelectField } from '@vestigas/ui';

import { CheckboxField } from './CheckboxField';
import { CheckboxGroupField } from './CheckboxGroupField';
import { ChipInputField } from './ChipInputField';
import { FileField } from './FileField';
import { fieldContext, formContext } from './form-context';
import { FormActionsRow } from './FormActionsRow';
import { JsonField } from './JsonField';
import { LocalizedNumberField } from './LocalizedNumberField';
import { MultiSelectCompaniesField } from './MultiSelectCompaniesField';
import { MultiSelectContractsField } from './MultiSelectContractsField';
import { MultiSelectCostCentersField } from './MultiSelectCostCentersField';
import { MultiSelectCountriesField } from './MultiSelectCountriesField';
import { MultiSelectCurrenciesField } from './MultiSelectCurrenciesField';
import { MultiSelectDeliveryNotesField } from './MultiSelectDeliveryNotesField';
import { MultiSelectSitesField } from './MultiSelectSitesField';
import { MultiSelectSuppliersField } from './MultiSelectSuppliersField';
import { MultiSelectUsersField } from './MultiSelectUsersField';
import { NumberField } from './NumberField';
import { RadioGroupField } from './RadioGroupField';
import { SliderField } from './SliderField';
import { SwitchField } from './SwitchField';
import { TextareaField } from './TextareaField';
import { TextField } from './TextField';
import { ToggleButtonField } from './ToggleButtonField';

export type TanstackFormType = ReturnType<typeof useAppForm>;

/**
 * Pre-configured TanStack Form hook with pre-bound custom UI components etc.
 *
 * @see https://tanstack.com/form/latest/docs/framework/react/guides/form-composition
 */
const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: {
    AutocompleteField,
    CheckboxField,
    CheckboxGroupField,
    ChipInputField,
    FileField,
    JsonField,
    ListManager,
    LocalizedNumberField,
    MultiSelectCompaniesField,
    MultiSelectContractsField,
    MultiSelectCostCentersField,
    MultiSelectCountriesField,
    MultiSelectCurrenciesField,
    MultiSelectDeliveryNotesField,
    MultiSelectSitesField,
    MultiSelectSuppliersField,
    MultiSelectUsersField,
    NumberField,
    RadioGroupField,
    SelectField,
    SliderField,
    SwitchField,
    TextareaField,
    TextField,
    ToggleButtonField,
  },
  fieldContext,
  formComponents: {
    ActionsRow: FormActionsRow,
    FormControl,
  },
  formContext,
});

export { useAppForm, withFieldGroup, withForm };
